export default __webpack_public_path__ + "static/media/primesedan_small.b3b03aad.png";